'use strict';

/* global $ */

function Menu(options) {

    let opt = $.extend({
        burger: options.selector+'__burger',
        close: options.selector+'__close',
        menu: options.selector+'__menu',
        block: options.selector+'__block',
        blockItem: options.selector+'__block-item',
    }, options);

    function initBlock(el) {
        console.log('[ Menu/Init ]');
        let $el = $(el);
        $el.find(opt.burger).on('click', function(e) {
            e.preventDefault();
            console.log('[ Menu/Open ]');
            $(opt.menu).addClass('is-open');
        });

        $el.find(opt.close).on('click', function(e) {
            e.preventDefault();
            console.log('[ Menu/Close ]');
            $(opt.menu).removeClass('is-open');
        });

        $el.find(opt.blockItem).on('click', function(e) {
            e.preventDefault();
            console.log('[ Menu/Toggle block ]');
            if ($(this).parents(opt.block).hasClass('is-open')) {
                $(this).parents(opt.block).removeClass('is-open');
            } else {
                $el.find(opt.block).removeClass('is-open');
                $(this).parents(opt.block).addClass('is-open');
            }
        });

        $('body').on('click', function(e) {
            if ($(e.target).closest(opt.block).length === 0) {
                $(opt.block).removeClass('is-open');
            }
        });
    }

    $(opt.selector).each(function() {
        initBlock(this);
    });
}

export {
    Menu
};
